module.exports = __webpack_public_path__ + "img/NOAA.29e88158.svg";